import { Component, HostBinding, Input } from '@angular/core';

export enum ButtonVariant {
  blue = 'blue',
  gray = 'gray',
  green = 'green',
  lightGray = 'lightGray',
  lightOrange = 'lightOrange',
  orange = 'orange',
  red = 'red',
  transparent = 'transparent',
  white = 'white',
}

export enum ButtonPadding {
  none = 'p-0',
  small = 'py-1.5 px-6',
  big = 'p-4',
}

export enum PlButtonType {
  button = 'button',
  submit = 'submit',
}

@Component({
  selector: 'pl-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @HostBinding('class') public classes: string = 'w-full block';
  @HostBinding('class.pointer-events-none') public get disabled(): boolean {
    return this.isDisabled;
  }

  @Input() public variant: ButtonVariant = ButtonVariant.blue;
  @Input() public isDisabled: boolean = false;
  @Input() public padding: ButtonPadding = ButtonPadding.big;
  @Input() public type: PlButtonType = PlButtonType.button;
  @Input() public timeToDisableButtonAfterClickInMs: number = 500;

  // Prevent rage clicking on buttons, we don't have use case where user needs
  // to click many times on a single button
  private buttonHasJustBeenClicked: boolean = false;

  public onButtonClick(event: MouseEvent): void {
    if (this.isDisabled || this.buttonHasJustBeenClicked) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    } else {
      this.buttonHasJustBeenClicked = true;
      setTimeout(() => {
        this.buttonHasJustBeenClicked = false;
      }, this.timeToDisableButtonAfterClickInMs);
    }
  }
}
